import React from 'react';

import cx from 'classnames';

import CampaignContentsRow from 'components/CampaignContentsRow/CampaignContentsRow';
import SectionWithContainer, {
  ISectionWithContainerProps,
} from 'components/PageBlocks/SectionWithContainer/SectionWithContainer';
import { ICampaignContent } from 'models/campaignContent';

interface IProps extends ISectionWithContainerProps {
  campaignContents: ICampaignContent[];
  colour: string;
}

const CampaignContentsSection: React.FC<IProps> = ({
  campaignContents,
  colour,
  className,
  ...props
}) => {
  return (
    <SectionWithContainer
      {...props}
      className={cx('overflow-hidden', className)}
    >
      <CampaignContentsRow
        campaignContents={campaignContents}
        colour={colour}
      />
    </SectionWithContainer>
  );
};

export default CampaignContentsSection;
